
import { defineComponent, nextTick, reactive, ref, toRefs, watch, computed, ComputedRef, createVNode, getCurrentInstance, onMounted, watchEffect } from 'vue'
import selectSlider from './selectSlider.vue'
import selectGroup from './selectGroup.vue'
import { initResult } from './enumData'
import type { ResultType, Option, ValueType } from './typings'
import { CloseCircleFilled, UpOutlined } from '@ant-design/icons-vue'

export default defineComponent({
  components: { selectSlider, selectGroup, CloseCircleFilled, UpOutlined },
  props: {
    theme: {
      type: String,
      default: () => {
        return 'light'
      }
    },
    item: {
      type: Object,
      default() {
        return {}
      }
    },
    showDelete: Boolean
  },
  setup(props: any, context) {
    type pageDataType = {
      fundTypeOptions: Option[]
      result: ResultType
      resultIdx: string[]
      groupName: string
    }
    const pageData: pageDataType = reactive({
      fundTypeOptions: [
        { label: '股票型', value: 1 },
        { label: '股票指数型', value: 2 },
        { label: '混合型', value: 4 },
        { label: '债券型', value: 8 },
        { label: 'FOF型', value: 16 }
      ],
      result: initResult,
      resultIdx: ['FundType'],
      groupName: ''
    })
    watch(
      () => props.item,
      (val) => {
        if (!val) return
        pageData.result = typeof val.result === 'string' ? JSON.parse(val.result) : val.result
        pageData.resultIdx = val.resultIdx
        pageData.groupName = val.groupName
      },
      {
        immediate: true
      }
    )

    const fundTypeValueToLable = (val: Array<number | undefined>, name: string) => {
      if (pageData.result?.FundType?.length === 5) return '全部'
      const res = pageData.fundTypeOptions.filter((item: any) => val.indexOf(item.value) > -1).map((i: Option) => i.label)
      return res.join('、')
    }
    // 把选中的结果展示成标签
    const valToLabel = (val: ValueType, name: string) => {
      let res = ''
      if (val.select1 && val.select1?.label && val.select1?.value !== -2) {
        res = val.select1.label
      }
      if (val.select2 && val.select2?.label) {
        res += (res ? ' / ' : '') + val.select2.label
      }
      if (val.range && val.range.length) {
        res += (res ? ' / ' : '') + val.range[0] + (val.unit || '') + ' ~ ' + val.range[1] + (val.unit || '')
      }
      return res
    }

    const clearCondition = (name: string) => {
      context.emit('clearCondition', name)
    }

    return {
      ...toRefs(pageData),
      valToLabel,
      fundTypeValueToLable,
      clearCondition
    }
  }
})
